import { render } from "./jlsetyyHospitalOrders.vue?vue&type=template&id=080e9a5d"
import script from "./jlsetyyHospitalOrders.vue?vue&type=script&lang=js"
export * from "./jlsetyyHospitalOrders.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__